import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat';
import { AcceptRejectUsers, IMessagesTasksInbox, ITaskReply } from 'src/app/models/IMessagesTasksInbox';
import { MessageInbox } from 'src/app/models/IMessaging';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { GroupNames, IMasterMessageType, TaskGroupUsers, TasksAndGroups, UserGroupMapping } from 'src/app/models/TasksAndGroups';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TasksAndGroupsService {

  constructor(private http: HttpClient) { }

  // Adding TaskAndmessagetype
  addMessageTypeInfo(messagetypeInfo: IMasterMessageType): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(messagetypeInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/messagetype'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Get messagetype
  getmessagetype(isactiveinactive: string): Observable<IMasterMessageType[]> {
    return this.http.get<IMasterMessageType[]>(`${configuration.apiUrl + 'TaskAndMessages/messagetypes'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${sessionStorage.getItem("FacilityId")}&&isactiveandinactive=${isactiveinactive}`);
  }

  // Update TaskAndmessagetype
  updatemessagetypes(messagetypesInfo: IMasterMessageType): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(messagetypesInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/messagetype'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetAllGroupNames(type: string): Observable<GroupNames[]> {
    return this.http.get<GroupNames[]>(
      `${configuration.apiUrl + 'TaskAndMessages/GroupName'}?Type=${type}&&FacilityId=${sessionStorage.getItem("FacilityId")}`);
  }
  SaveOrUpdateGroupName(groupInfo: GroupNames): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(groupInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/Group'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetAllTaskMessagesInbox(checkInboxSend: string = "", locations: string = "", dateMonthYear: string = "", fromDate: string = "", toDate: string = "", dueDate: string, IsCheckedDueDate: number): Observable<IMessagesTasksInbox[]> {
    ;
    return this.http.get<IMessagesTasksInbox[]>(
      `${configuration.apiUrl + 'TaskAndMessages/GetTaskMessagesInbox'}?locationsList=${locations}&&dayMonthYearSelect=${dateMonthYear}&&FromDate=${fromDate}&&ToDate=${toDate}&&facility=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId"))}&&checkInboxSend=${checkInboxSend}&&dueDate=${dueDate}&&IsCheckedDueDate=${IsCheckedDueDate}`);
  }
  DeleteGroupName(element: GroupNames): Observable<string> {
    element.CreatedBy = encodeURIComponent(sessionStorage.getItem("userId"));
    element.CreatedOn = new Date();
    const posteddata = {
      inputdata: JSON.stringify(element)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/DelGroupName'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getAllMappedGroupUsers(groupId: number, type: string): Observable<any> {
    return this.http.get<any>(
      `${configuration.apiUrl + 'TaskAndMessages/AllUsersByGroup'}?userid=${encodeURIComponent(sessionStorage.getItem("userId"))}&&facilityid=${sessionStorage.getItem("FacilityId")}&&gropuId=${groupId}&&Type=${type}`);
  }

  AddGroupNameWithUsers(_selectUsers: string, _groupId: number, _type: string): Observable<UserGroupMapping[]> {
    const posteddata = {
      selectUsers: _selectUsers,
      groupId: _groupId,
      userId: sessionStorage.getItem("userId"),
      locId: Number(sessionStorage.getItem("LocationId")),
      createdOn: new Date(),
      facId: Number(sessionStorage.getItem("FacilityId")),
      type: _type
    }
    return this.http.post<UserGroupMapping[]>(`${configuration.apiUrl + 'TaskAndMessages/GroupUsers'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // Get Message Tasks View By ID
  getMessagesViewById(Id: number): Observable<IMessagesTasksInbox[]> {
    return this.http.get<IMessagesTasksInbox[]>(`${configuration.apiUrl + 'TaskAndMessages/ViewTaskMeassages'}?ID=${Id}`);
  }
  getTaskGroupedUsers(): Observable<TaskGroupUsers[]> {
    return this.http.get<TaskGroupUsers[]>(`${configuration.apiUrl + 'TaskAndMessages/TaskGroupedUser'}?facilityid=${sessionStorage.getItem("FacilityId")}`);
  }

  SaveTasksInfo(taskInfo: IMessagesTasksInbox): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(taskInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/MessagesTask'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // Forward Reply Message Task
  SaveFarwardReplyTasksInfo(taskInfo: IMessagesTasksInbox): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(taskInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/ForwardRepMessagesTask'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //** Save Notes on Messages and Tasks */
  SaveTasksNotes(taskInfo: IMessagesTasksInbox): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(taskInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/MessagesTaskNotes'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // Get Message Tasks Notes
  getTaskMessagesNotes(type: string, taskId: number): Observable<IMessagesTasksInbox[]> {
    ;
    return this.http.get<IMessagesTasksInbox[]>(`${configuration.apiUrl + 'TaskAndMessages/MessagesTaskNotes'}?type=${type}&&Id=${taskId}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  //** Replay Notes */
  SaveReplyNotes(taskInfo: ITaskReply): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(taskInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/ReplyMessage'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // Get Message Reply Information
  getReplyNotes(taskId: number): Observable<ITaskReply[]> {
    return this.http.get<ITaskReply[]>(`${configuration.apiUrl + 'TaskAndMessages/ReplyDetails'}?taskId=${taskId}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  // Get Message Tasks View By ID
  GetAcceptAndRejectUserList(Id: number): Observable<AcceptRejectUsers[]> {
    return this.http.get<AcceptRejectUsers[]>(`${configuration.apiUrl + 'TaskAndMessages/AcceptRejectUsers'}?Id=${Id}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }
  // Get Inbox Message By TaskId
  GetInboxMessageByTaskId(TaskId): Observable<IMessagesTasksInbox> {
    return this.http.get<IMessagesTasksInbox>(
      `${configuration.apiUrl + 'TaskAndMessages/GetInboxMessageById'}?taskId=${TaskId}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  // Get All Messages From Tracker
  GetAllTaskMessagesTracker(locations: string = "", dateMonthYear: string = "", fromDate: string = "", toDate: string = "", userId: string = ""): Observable<IMessagesTasksInbox[]> {
    ;
    return this.http.get<IMessagesTasksInbox[]>(
      `${configuration.apiUrl + 'TaskAndMessages/GetAllTaskMessagesTracker'}?locationsList=${locations}&&dayMonthYearSelect=${dateMonthYear}&&FromDate=${fromDate}&&ToDate=${toDate}&&facility=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(userId)}`);
  }

  // Get Inbox Message By TaskId
  GetForwardReplyByTaskId(TaskId): Observable<IMessagesTasksInbox[]> {
    return this.http.get<IMessagesTasksInbox[]>(
      `${configuration.apiUrl + 'TaskAndMessages/ForwardReplyTaskMeassages'}?ID=${TaskId}&&facilityId=${sessionStorage.getItem("FacilityId")}&&FromUserId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getMessagesTasksCount(): Observable<any> {
    return this.http.get<any>(
      `${configuration.apiUrl + 'TaskAndMessages/MessagesTasksCount'}?userid=${encodeURIComponent(sessionStorage.getItem("userId"))}&&facilityid=${sessionStorage.getItem("FacilityId")}`);
  }

  UpdateIsReadedTasksInfo(IsReadableInfo: IMessagesTasksInbox): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(IsReadableInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/UpdateIsReadedById'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //*** Create New Secure Message */
  SaveSecureMessageInfo(taskInfo: IMessagesTasksInbox): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(taskInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'TaskAndMessages/SecureMessages'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //****** Patient Portal Inbox Message Request */

  getAllSecureMessages(secureMessageId, type: string): Observable<MessageInbox[]> {
    return this.http.get<MessageInbox[]>(
      `${configuration.clinicapiUrl + 'Encounter/SecureMessages'}?userid=${encodeURIComponent(sessionStorage.getItem("userId"))}&&Type=${type}&&patientId=0&&facilityid=${sessionStorage.getItem("FacilityId")}&&secureMessageId=${secureMessageId}`);
  }
}
